module.exports = __webpack_public_path__ + "img/com11.428b835f.gif";